import React from "react";
import Link from "next/link";
import { useSelector, useDispatch } from 'react-redux'
import { useRouter } from "next/router";
import dayjs from 'dayjs';

import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(advancedFormat)



// controlelrs
import { _apiPost, _apiGet } from '@/controllers/api'
import { _groupBy, useWindowSize, _timeout } from '@/controllers/helpers'
import _actions from "@/controllers/redux/actions";

// components
import Layout from '@/components/Layout'
import Loading from "@/components/Loading";
import Modal from "@/components/Modal";
import CustomSelect from "@/components/CustomSelect";
import CustomDatePicker from "@/components/CustomDatePicker";
import CustomTimeSelectButton from "@/components/CustomTimeSelectButton";


// 
// 
const AppointmentSearch = (props) => {
    
    const dispatch = useDispatch()
    const router = useRouter()
    const isFirstLoad = React.useRef(true)
	const auth = useSelector(state => state.auth.payload)
    const windowSize = useWindowSize()
    const layoutRef = React.useRef(null)

    const clinicialsDefault = [
        [
            {FullName:'Male',Key:'male'},{FullName:'Female',Key:'female'}
        ],
        ['line']
    ]

    const paramsDefault = {
        'client-key': process.env.NEXT_PUBLIC_CLIENT_KEY,
        'payer-type': process.env.NEXT_PUBLIC_PAYER_TYPE
    }

    const [ isLoading, setLoading ] = React.useState(true)
    const [ isLoadingSites, setLoadingSites ] = React.useState(true)
    const [ isLoadingClinicians, setLoadingClinicians ] = React.useState(true)
    const [ isExpanded, setIsExpanded ] = React.useState(true)
    const [ isFound, setIsFound ] = React.useState(true)
    const [ isInitialized, setInitialized ] = React.useState(false)
    const [ hasNotification, setHasNotification ] = React.useState(null)
    const [ showNotificationModal, setShowNotificationModal ] = React.useState(null)
    const [ appointmentType, setAppointmentType ] = React.useState(null)
    const [ appointmentTypes, setAppointmentTypes ] = React.useState(null)
    const [ appointmentSites, setAppointmentSites ] = React.useState(null)
    const [ appointmentProposed, setAppointmentProposed ] = React.useState(null)
    const [ appointmentClinicians, setAppointmentClinicians ] = React.useState(clinicialsDefault)

    const [ currentProposedAppointment, setCurrentProposedAppointment ] = React.useState(null)
    const [ currentSite, setCurrentSite ] = React.useState(null)
    const [ currentClinician, setCurrentClinician ] = React.useState(null)
    const [ currentDate, setCurrentDate ] = React.useState(null)
    


    // 
    // 
    const _parseProposedAppointments = async(data) => {

		let finalArray = []

		for (let i = 0; i < data.length; i++) {

            const item = data[i];

            const ifExist = finalArray.find(x => x.Start===item.Start) ? true : false
            if(!ifExist){
                let newItem = {...item}
                newItem.date = dayjs(item.Start).format('YYYY-MM-DD')
                finalArray.push(newItem)
            }

        }


		const groupping =  _groupBy('date')
        setAppointmentProposed(groupping(finalArray))

    }


    // 
    // 
    const _getSites = async(id=null) => {

        setLoadingSites(true)
        let params = paramsDefault
        params['appointment-type'] = appointmentType[appointmentType.type].Key

		const get = await _apiGet('/patientportalapi/anon-appointment/sites', { params:params })
		if(get?.result){
			setAppointmentSites(get.result)
            if(id && isFirstLoad.current){
                const find = get.result.find(x => x.Key===parseInt(id))
                if(find){
                    await setCurrentSite(find)
                }
            }
		}
        setLoadingSites(false)

    }


    // 
    // 
    const _getClinicians = async(id=null, site=null) => {

        setLoadingClinicians(true)
        let data = {}
        let params = paramsDefault
        params['appointment-type'] = appointmentType[appointmentType.type].Key

        if(currentSite){
            data['sites'] = [currentSite.Key]
        }

        if(site && isFirstLoad.current){
            data['sites'] = [site]
        }

		const get = await _apiPost('/patientportalapi/anon-appointment/clinicians', { params:params, data:data, headers:{'Content-Type': 'multipart/form-data'} })
		if(get?.result){
			setAppointmentClinicians([...clinicialsDefault, get.result])
            if(id && isFirstLoad.current){
                const find = get.result.find(x => x.Key===parseInt(id))
                if(find){
                    await setCurrentClinician(find)
                }
            }
		}
        setLoadingClinicians(false)

    }


    // 
    // 
    const _getProposedApointment = async(clinician=null, site=null) => {

        let params = paramsDefault
        params['appointment-type'] = appointmentType[appointmentType.type].Key

        if(currentSite){
            params['site'] = currentSite.Key
        }
        if(currentClinician){
            if(currentClinician.Key==='male'){
                params['clinician-sex'] = 1
            }else if(currentClinician.Key==='female'){
                params['clinician-sex'] = 2
            }else{
                params['clinician'] = currentClinician.Key
            }
        }
        if(currentDate){
            params['from-date'] = dayjs(currentDate).format('YYYY-MM-DD')
        }

        if(site && isFirstLoad.current){
            params['site'] = site
        }
        if(clinician && isFirstLoad.current){
            params['clinician'] = clinician
        }

		const get = await _apiGet('/patientportalapi/anon-appointment/proposed', { params:params })
		if(get?.result){
            await _parseProposedAppointments(get.result)
            setIsFound(true)
        }else{
            setAppointmentProposed(null)
            setIsFound(false)
            setLoading(false)
        }

    }


    // 
    // 
    const _onChangeAppointmentType = async(value) => {
        await setAppointmentType(value)
        await dispatch(_actions.auth.authUpdate({...auth, appointmentType:value}))
        setHasNotification(value.notification ? value.notification : null)
        if(value.notification){
            setHasNotification(value.notification)
        }
    } 


    // 
    // 
    const _submit = async() =>{
        await dispatch(_actions.auth.authUpdate({...auth, appointment:currentProposedAppointment}))
        setShowNotificationModal(null)
        router.push('/patient-registration')
    }


    // 
    // 
    const scrollToBottom = () => {
        layoutRef.current.scrollIntoView({ behavior: "smooth" });
    }

    
    // 
    // 
    React.useEffect(()=>{

        const init = async() => {

            if(auth?.expire && dayjs().isBefore(dayjs(auth.expire))){
                await setAppointmentType(auth.appointmentType)
                setAppointmentTypes(auth.appointmentTypes)
                setHasNotification(auth.appointmentType.notification ? auth.appointmentType.notification : null)
            }else{
                await dispatch(_actions.auth.authLogout())
		        router.push('/')
            }
        }

        init()

    },[])

    
    // 
    // 
    React.useEffect(()=>{

        const _fetching = async() => {
            setLoading(true)
            console.log('AUTH',auth)
            await _getSites(auth.site ? auth.site : null)
            await _getClinicians(auth.clinician ? auth.clinician : null, auth.site ? auth.site : null)
            await _getProposedApointment(auth.clinician ? auth.clinician : null, auth.site ? auth.site : null)
            setInitialized(true)
            isFirstLoad.current = false
        }

        if(appointmentType){
            setCurrentProposedAppointment(null)
            setCurrentClinician(null)
            setCurrentDate(null)
            setCurrentSite(null)
            setAppointmentSites(null)
            setAppointmentClinicians(null)
            setAppointmentProposed(null)
            _fetching()
        }

    },[appointmentType])

    
    // 
    // 
    React.useEffect(()=>{

        const _fetching = async() => {
            setLoading(true)
            setCurrentProposedAppointment(null)
            await _getClinicians()
            await _getProposedApointment()
        }

        if(isInitialized){
            setAppointmentClinicians(null)
            setAppointmentProposed(null)
            _fetching()
        }

    },[currentSite])

    
    // 
    // 
    React.useEffect(()=>{

        const _fetching = async() => {
            setLoading(true)
            setCurrentProposedAppointment(null)
            await _getSites()
            await _getProposedApointment()
        }

        if(isInitialized){
            setAppointmentProposed(null)
            setAppointmentSites(null)
            _fetching()
        }

    },[currentClinician, currentDate])


    // 
    // 
    React.useEffect(()=>{
        if(windowSize?.width<1024 && isExpanded){
            setIsExpanded(true)
        }else if(windowSize?.width >= 1024 && !isExpanded){
            setIsExpanded(true)
        }
    },[windowSize?.width])


    // 
    // 
    React.useEffect(()=>{
        setLoading(false)
    },[appointmentProposed])

    
    // 
    // 
    return(
        <Layout public>

            <div className='container pb-10'>

                <p className='mb-8'>
                    <Link href={'/'}>Explore</Link>
                     &gt; 
                     Appointment search
                </p>

                <div className='flex justify-start items-start p-4 bg-custom-green-light border border-custom-green rounded'>
                    <span className="material-symbols-outlined mr-2 -my-1">error</span>
					<p className="my-0">If you are already a registered client with us, and have completed one or more sessions, <Link href={process.env.NEXT_PUBLIC_LOGIN_LINK} className='underline' target="_blank">please login to the portal</Link> to book your follow up appointment</p>
                </div>

                <div className="flex flex-col md:flex-row flex-wrap justify-between items-center mt-8 gap-4 md:gap-0">
                    <div className="w-full md:w-1/2 lg:w-4/12 md:pr-0 lg:pr-0">
                        <CustomSelect
                            options={appointmentTypes ? Object.values(appointmentTypes) : null}
                            optionKey="title"
                            optionAddon="type"
                            defaultValue={appointmentType}
                            onChange={_onChangeAppointmentType}
                        />
                    </div>
                    <div className="w-full md:w-1/2 lg:w-3/12 md:pl-3 pr-0 pt-0 md:pt-0">
                        <CustomSelect
                            options={appointmentSites ? [appointmentSites] : null}
                            optionKey="Name"
                            showAny="Any location"
                            defaultValue={currentSite}
                            onChange={setCurrentSite}
                            isLoading={isLoadingSites}
                        />
                    </div>
                    <div className="w-full md:w-1/2 lg:w-3/12 lg:pl-3 pr-0 lg:pr-0 md:pt-2 lg:pt-0">
                        <CustomDatePicker
                            defaultValue={currentDate}
                            onChange={setCurrentDate}
                            placeHolder="Select date"
                        />
                    </div>
                    <div className="w-full md:w-1/2 lg:w-2/12 md:pl-3 md:pt-2 lg:pt-0">
                        <CustomSelect
                            options={appointmentClinicians ? Object.values(appointmentClinicians) : []}
                            optionKey="FullName"
                            showAny="Any clinician"
                            defaultValue={currentClinician}
                            onChange={setCurrentClinician}
                            isLoading={isLoadingClinicians}
                        /> 
                    </div>
                </div>

                <div className="flex flex-col md:flex-row justify-between gap-6 relative z-0">
                    <div className="w-full md:w-7/12">

                        {appointmentProposed &&
                        <>
                            {Object.values(appointmentProposed).map((day,i1)=>{
                                return(
                                    <div className="my-6" key={i1}>
                                        <div className="bg-gray-100 px-6 py-4 rounded-lg font-bold">{dayjs(Object.keys(appointmentProposed)[i1]).format('dddd Do of MMMM')}</div>
                                        <div className=" my-6 flex flex-wrap gap-2">
                                            {day.length>0 && day.map((time,i2)=>{
                                                return(
                                                    <CustomTimeSelectButton
                                                        key={i2}
                                                        title={dayjs(time.Start).format('HH:mm')}
                                                        isSelected={(currentProposedAppointment && currentProposedAppointment.i1===i1 && currentProposedAppointment.i2===i2) ? true : false}
                                                        onChange={()=>{
                                                            if(windowSize.width<1024){
                                                                scrollToBottom()
                                                            }
                                                            setCurrentProposedAppointment({item:time, i1:i1, i2:i2})
                                                        }}
                                                    />
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })}
                        </>
                        }

                        {(!isLoading && !isFound) && 
                            <p className="text-center py-10 text-base">
                                We apologize, but it seems there are currently no available slots that match your selected filter criteria.<br/>
                                Please adjust your search criteria and try again.
                            </p>
                        }

                    </div>

                    <div className="w-full md:w-5/12 relative z-[0]">
                    {appointmentType &&
                        <div className='shadow-lg rounded-lg overflow-hidden flex flex-col flex-1 my-6'>
                            <div className='bg-primary py-4 px-6 text-white text-base font-semibold flex justify-between items-center'>
                                <span>Your selected appointment</span>
                                {windowSize.width<1024 && <button type="button" onClick={()=>setIsExpanded(!isExpanded)} className="py-3 px-4 -mr-5 -my-5 block"><span className="material-symbols-outlined mt-1">expand_more</span></button>}
                            </div>
                            <div className='flex flex-col flex-1 justify-between'>
                                <div className="py-2 px-6 flex justify-between gap-6">
                                    <p>
                                        <span className="font-semibold">{appointmentType.title}</span>
                                        {currentProposedAppointment &&
                                        <>
                                            <span className="block">{dayjs(currentProposedAppointment.item.Start).format('dddd Do of MMMM')} at {dayjs(currentProposedAppointment.item.Start).format('HH:mm')}</span>
                                            <span className="block">with {currentProposedAppointment.item.Clinician.FullName}</span>
                                            <span className="block">Price {currentProposedAppointment.item.Modules[0].CurrencySymbol}{currentProposedAppointment.item.Modules[0].NetPrice}</span>
                                        </>
                                        }
                                    </p>
                                    {currentProposedAppointment &&<button type="button" className="button mt-6 mb-4" onClick={()=> hasNotification ? setShowNotificationModal(hasNotification) : _submit()}>Book</button>}
                                </div>
                                <hr className={`${isExpanded ? 'scale-y-100' : 'scale-y-0 h-0'} transition-all ease-in-out`} />
                                {currentProposedAppointment &&
                                <div className={`${isExpanded ? 'scale-y-100' : 'scale-y-0 h-0'} transition-all ease-in-out`}>
                                    <div className="py-2 px-6 flex justify-between items-end gap-6">
                                        <p>
                                            <span className="block font-semibold">{currentProposedAppointment.item.Site.Name}</span>
                                            {currentProposedAppointment.item.Site.Address.Address1 && 
                                                <span className="block">
                                                    {currentProposedAppointment.item.Site.Address.Address1} 
                                                    {currentProposedAppointment.item.Site.Address.Address2 && <>, {currentProposedAppointment.item.Site.Address.Address2}</>}
                                                    {currentProposedAppointment.item.Site.Address.County && <>, {currentProposedAppointment.item.Site.Address.County}</>}
                                                </span>
                                            }
                                            <span className="block">
                                                {currentProposedAppointment.item.Site.Address.City && currentProposedAppointment.item.Site.Address.City}
                                                {currentProposedAppointment.item.Site.Address.PostCode && <>, {currentProposedAppointment.item.Site.Address.PostCode}</>}
                                            </span>
                                        </p>
                                        <Link href={`https://www.google.com/maps/place/${currentProposedAppointment.item.Site.Address.Address1 ? currentProposedAppointment.item.Site.Address.Address1 : ''}${currentProposedAppointment.item.Site.Address.City ? ','+currentProposedAppointment.item.Site.Address.City : ''}${currentProposedAppointment.item.Site.Address.PostCode ? ','+currentProposedAppointment.item.Site.Address.PostCode : ''},+Ireland`} target='_blank'>
                                        <span className="material-symbols-outlined mt-6 mb-4">map</span>
                                        </Link>
                                    </div>
                                    <hr className="" />
                                </div>
                                }
                                <div className={`py-2 px-6 overflow-hidden ${isExpanded ? 'scale-y-100' : 'scale-y-0 h-0'} transition-all ease-in-out`}  ref={layoutRef}>
                                    <div className="typography" dangerouslySetInnerHTML={{ __html: appointmentType.description}}/>
                                </div>
                            </div>
                        </div>
                    }
                    </div>
                </div>

            </div>

            <Modal
                status={showNotificationModal}
                title="Before you continue"
                size="max-w-lg"
                content={<div dangerouslySetInnerHTML={{ __html: showNotificationModal}} />}
                footer={
                    <div className="flex justify-center items-center gap-2">
                        <button type="button" className="button gray" onClick={()=>setShowNotificationModal(null)}>Cancel</button>
                        <button type="button" className="button" onClick={()=>_submit()}>Accept</button>
                    </div>
                }
            />

            <Loading status={isLoading} />
        </Layout>
    )
}

export default AppointmentSearch